module.exports = __webpack_public_path__ + "media/application/images/colors/books_orange-86e4df0a3afc5871fe8b8c622a859c1b.png";